import React from "react";
import { createMarkup } from "../../../Helpers";
import { Image } from "../../../../styles";

export default function IconBar({ icons }) {

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-6 gap-8 md:gap-6">
      {icons &&
        icons.map((icon, i) => (
          <div key={i} className="text-center">
            <Image src={icon.icon_image.url} alt="" className="mb-5" />
            <div dangerouslySetInnerHTML={createMarkup(icon.icon_text)} className="text-base" />
          </div>
        ))}
    </div>
  );
}
